import _assertThisInitialized from "E:\\Projects\\shl\\shl-frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/assertThisInitialized";
import _toConsumableArray from "E:\\Projects\\shl\\shl-frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "E:\\Projects\\shl\\shl-frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import _possibleConstructorReturn from "E:\\Projects\\shl\\shl-frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "E:\\Projects\\shl\\shl-frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _inherits from "E:\\Projects\\shl\\shl-frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/inherits";
import _wrapNativeSuper from "E:\\Projects\\shl\\shl-frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/wrapNativeSuper";
import _classCallCheck from "E:\\Projects\\shl\\shl-frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "E:\\Projects\\shl\\shl-frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(typeof e + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols) {
    var _iterator = _createForOfIteratorHelper(__getOwnPropSymbols(b)),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var prop = _step.value;
        if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  return a;
};
var __spreadProps = function __spreadProps(a, b) {
  return __defProps(a, __getOwnPropDescs(b));
};
var __objRest = function __objRest(source, exclude) {
  var target = {};
  for (var prop in source) if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols) {
    var _iterator2 = _createForOfIteratorHelper(__getOwnPropSymbols(source)),
      _step2;
    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var prop = _step2.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  }
  return target;
};
var __accessCheck = function __accessCheck(obj, member, msg) {
  if (!member.has(obj)) throw TypeError("Cannot " + msg);
};
var __privateGet = function __privateGet(obj, member, getter) {
  __accessCheck(obj, member, "read from private field");
  return getter ? getter.call(obj) : member.get(obj);
};
var __privateAdd = function __privateAdd(obj, member, value) {
  if (member.has(obj)) throw TypeError("Cannot add the same private member more than once");
  member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
};
var __privateSet = function __privateSet(obj, member, value, setter) {
  __accessCheck(obj, member, "write to private field");
  setter ? setter.call(obj, value) : member.set(obj, value);
  return value;
};
var __privateWrapper = function __privateWrapper(obj, member, setter, getter) {
  return {
    set _(value) {
      __privateSet(obj, member, value, setter);
    },
    get _() {
      return __privateGet(obj, member, getter);
    }
  };
};
var __privateMethod = function __privateMethod(obj, member, method) {
  __accessCheck(obj, member, "access private method");
  return method;
};
var __async = function __async(__this, __arguments, generator) {
  return new Promise(function (resolve, reject) {
    var fulfilled = function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = function rejected(value) {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = function step(x) {
      return x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    };
    step((generator = generator.apply(__this, __arguments)).next());
  });
};

// src/autofill/constants.ts
var SEARCH_URL = "https://api.mapbox.com/autofill/v1";
var ENDPOINT_SUGGEST = "suggest";
var ENDPOINT_RETRIEVE = "retrieve";
var SUGGEST_URL = "".concat(SEARCH_URL, "/").concat(ENDPOINT_SUGGEST);
var RETRIEVE_URL = "".concat(SEARCH_URL, "/").concat(ENDPOINT_RETRIEVE);

// src/LngLat.ts
var LngLat = /*#__PURE__*/function () {
  function LngLat(lng, lat) {
    _classCallCheck(this, LngLat);
    if (isNaN(lng) || isNaN(lat)) {
      throw new Error("Invalid LngLat object: (".concat(lng, ", ").concat(lat, ")"));
    }
    this.lng = +lng;
    this.lat = +lat;
    if (this.lat > 90 || this.lat < -90) {
      throw new Error("Invalid LngLat latitude value: must be between -90 and 90");
    }
    if (this.lng > 180 || this.lng < -180) {
      throw new Error("Invalid LngLat longitude value: must be between -180 and 180");
    }
  }
  _createClass(LngLat, [{
    key: "toArray",
    value: function toArray() {
      return [this.lng, this.lat];
    }
  }, {
    key: "toString",
    value: function toString() {
      return "LngLat(".concat(this.lng, ", ").concat(this.lat, ")");
    }
  }], [{
    key: "convert",
    value: function convert(input) {
      if (input instanceof LngLat) {
        return new LngLat(input.lng, input.lat);
      }
      if (Array.isArray(input) && input.length === 2) {
        return new LngLat(Number(input[0]), Number(input[1]));
      }
      if (!Array.isArray(input) && typeof input == "object" && input !== null && ("lng" in input || "lon" in input) && "lat" in input) {
        return new LngLat(Number("lng" in input ? input.lng : input.lon), Number(input.lat));
      }
      throw new Error("`LngLatLike` argument must be specified as an object {lng: <lng>, lat: <lat>}, an object {lon: <lng>, lat: <lat>}, or an array of [<lng>, <lat>]");
    }
  }]);
  return LngLat;
}();

// src/LngLatBounds.ts
var LngLatBounds = /*#__PURE__*/function () {
  function LngLatBounds(sw, ne) {
    _classCallCheck(this, LngLatBounds);
    this._sw = LngLat.convert(sw);
    this._ne = LngLat.convert(ne);
  }
  _createClass(LngLatBounds, [{
    key: "getSouthWest",
    value: function getSouthWest() {
      return this._sw;
    }
  }, {
    key: "getNorthEast",
    value: function getNorthEast() {
      return this._ne;
    }
  }, {
    key: "getNorthWest",
    value: function getNorthWest() {
      return new LngLat(this.getWest(), this.getNorth());
    }
  }, {
    key: "getSouthEast",
    value: function getSouthEast() {
      return new LngLat(this.getEast(), this.getSouth());
    }
  }, {
    key: "getWest",
    value: function getWest() {
      return this._sw.lng;
    }
  }, {
    key: "getSouth",
    value: function getSouth() {
      return this._sw.lat;
    }
  }, {
    key: "getEast",
    value: function getEast() {
      return this._ne.lng;
    }
  }, {
    key: "getNorth",
    value: function getNorth() {
      return this._ne.lat;
    }
  }, {
    key: "toArray",
    value: function toArray() {
      return [this._sw.toArray(), this._ne.toArray()];
    }
  }, {
    key: "toFlatArray",
    value: function toFlatArray() {
      return [this._sw.lng, this._sw.lat, this._ne.lng, this._ne.lat];
    }
  }, {
    key: "toString",
    value: function toString() {
      return "LngLatBounds(".concat(this._sw.toString(), ", ").concat(this._ne.toString(), ")");
    }
  }], [{
    key: "convert",
    value: function convert(input) {
      if (!input) {
        throw new Error("Invalid LngLatBounds convert value: falsy");
      }
      if (input instanceof LngLatBounds) {
        return new LngLatBounds(input.getSouthWest(), input.getNorthEast());
      }
      if (Array.isArray(input) && input.length === 2) {
        return new LngLatBounds(LngLat.convert(input[0]), LngLat.convert(input[1]));
      }
      if (Array.isArray(input) && input.length === 4) {
        return new LngLatBounds(LngLat.convert([input[0], input[1]]), LngLat.convert([input[2], input[3]]));
      }
      throw new Error("`LngLatBoundsLike` argument must be specified as an array [<LngLatLike>, <LngLatLike>] or an array [<west>, <south>, <east>, <north>]");
    }
  }]);
  return LngLatBounds;
}();

// src/utils/uuid.ts
function generateUUID() {
  var randomString = Math.random().toString(16) + Date.now().toString(16) + Math.random().toString(16);
  var uuidString = randomString.replace(/\./g, "");
  var uuid = [uuidString.slice(0, 8), uuidString.slice(8, 12), "4" + uuidString.slice(12, 15) + "-8" + uuidString.slice(15, 18), uuidString.slice(18, 30)].join("-");
  return uuid;
}

// src/SessionToken.ts
var SessionToken = /*#__PURE__*/function () {
  function SessionToken(id) {
    _classCallCheck(this, SessionToken);
    this.id = id != null ? id : generateUUID();
  }
  _createClass(SessionToken, [{
    key: "toString",
    value: function toString() {
      return this.id;
    }
  }], [{
    key: "convert",
    value: function convert(token) {
      return new SessionToken(token instanceof SessionToken ? token.id : token.toString());
    }
  }]);
  return SessionToken;
}();

// src/MapboxError.ts
var UNKNOWN_ERROR = "Unknown error";
var MapboxError = /*#__PURE__*/function (_Error) {
  _inherits(MapboxError, _Error);
  function MapboxError(json, statusCode) {
    var _this;
    _classCallCheck(this, MapboxError);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(MapboxError).call(this, String(json.message || json.error || UNKNOWN_ERROR)));
    _this.name = "MapboxError";
    _this.statusCode = statusCode;
    return _this;
  }
  _createClass(MapboxError, [{
    key: "toString",
    value: function toString() {
      return "".concat(this.name, " (").concat(this.statusCode, "): ").concat(this.message);
    }
  }]);
  return MapboxError;
}(_wrapNativeSuper(Error));
function handleNonOkRes(res) {
  return __async(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
    var json;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          if (res.ok) {
            _context.next = 5;
            break;
          }
          _context.next = 3;
          return res.json();
        case 3:
          json = _context.sent;
          throw new MapboxError(json, res.status);
        case 5:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
}

// src/fetch.ts
var _fetchImpl = globalThis.fetch;
var _abortControllerImpl = globalThis.AbortController;
function polyfillFetch(_ref) {
  var fetch = _ref.fetch,
    AbortController = _ref.AbortController;
  var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  if (!fetch) {
    throw new Error("Fetch implementation must include implementations of `fetch`.");
  }
  if (_fetchImpl && !force) {
    return;
  }
  _fetchImpl = fetch;
  _abortControllerImpl = AbortController;
}
function getFetch() {
  if (!_fetchImpl) {
    throw new Error("Fetch implementation not found. Please include a fetch polyfill in your application or use `polyfillFetch` from `@mapbox/search-js-core` to fix this issue.");
  }
  return {
    fetch: _fetchImpl,
    AbortController: _abortControllerImpl
  };
}

// src/utils/queryParams.ts
function queryParams() {
  var params = [];
  for (var _len = arguments.length, objects = new Array(_len), _key = 0; _key < _len; _key++) {
    objects[_key] = arguments[_key];
  }
  for (var _i = 0, _objects = objects; _i < _objects.length; _i++) {
    var obj = _objects[_i];
    if (!obj) continue;
    var entries = Object.entries(obj);
    for (var _i2 = 0, _entries = entries; _i2 < _entries.length; _i2++) {
      var _entries$_i = _slicedToArray(_entries[_i2], 2),
        key = _entries$_i[0],
        value = _entries$_i[1];
      if (value == null) continue;
      params.push("".concat(key, "=").concat(encodeURIComponent(String(value))));
    }
  }
  return params.join("&");
}

// src/autofill/AddressAutofillCore.ts
var _responseHeaders, _getQueryParams, getQueryParams_fn;
var _AddressAutofillCore = /*#__PURE__*/function () {
  function _AddressAutofillCore() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    _classCallCheck(this, _AddressAutofillCore);
    __privateAdd(this, _getQueryParams);
    __privateAdd(this, _responseHeaders, void 0);
    var _a = options,
      accessToken = _a.accessToken,
      defaults = __objRest(_a, ["accessToken"]);
    this.accessToken = accessToken;
    this.defaults = __spreadValues(__spreadValues({}, _AddressAutofillCore.defaults), defaults);
  }
  _createClass(_AddressAutofillCore, [{
    key: "suggest",
    value: function suggest(searchText, optionsArg) {
      return __async(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var sessionToken, signal, options, url, _getFetch, fetch, res, json;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (searchText) {
                _context2.next = 2;
                break;
              }
              throw new Error("searchText is required");
            case 2:
              sessionToken = optionsArg.sessionToken, signal = optionsArg.signal;
              options = __spreadProps(__spreadValues(__spreadValues({}, this.defaults), optionsArg), {
                sessionToken: sessionToken
              });
              url = new URL("".concat(SUGGEST_URL, "/").concat(encodeURIComponent(searchText)));
              url.search = __privateMethod(this, _getQueryParams, getQueryParams_fn).call(this, options);
              _getFetch = getFetch(), fetch = _getFetch.fetch;
              _context2.next = 9;
              return fetch(url.toString(), {
                signal: signal
              });
            case 9:
              res = _context2.sent;
              __privateSet(this, _responseHeaders, res.headers);
              _context2.next = 13;
              return handleNonOkRes(res);
            case 13:
              _context2.next = 15;
              return res.json();
            case 15:
              json = _context2.sent;
              return _context2.abrupt("return", __spreadProps(__spreadValues({}, json), {
                suggestions: json.suggestions.map(function (suggestion) {
                  return __spreadProps(__spreadValues({}, suggestion), {
                    original_search_text: searchText
                  });
                }),
                url: url.toString()
              }));
            case 17:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
    }
  }, {
    key: "retrieve",
    value: function retrieve(suggestion, optionsArg) {
      return __async(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var sessionTokenLike, signal, sessionToken, url, _getFetch2, fetch, res, json;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              if (suggestion) {
                _context3.next = 2;
                break;
              }
              throw new Error("suggestion is required");
            case 2:
              if (this.canRetrieve(suggestion)) {
                _context3.next = 4;
                break;
              }
              throw new Error("suggestion cannot be retrieved");
            case 4:
              sessionTokenLike = optionsArg.sessionToken, signal = optionsArg.signal;
              sessionToken = SessionToken.convert(sessionTokenLike);
              url = new URL("".concat(RETRIEVE_URL, "/").concat(suggestion.action.id));
              url.search = queryParams({
                access_token: this.accessToken,
                session_token: sessionToken.id
              });
              _getFetch2 = getFetch(), fetch = _getFetch2.fetch;
              _context3.next = 11;
              return fetch(url.toString(), {
                signal: signal
              });
            case 11:
              res = _context3.sent;
              _context3.next = 14;
              return handleNonOkRes(res);
            case 14:
              _context3.next = 16;
              return res.json();
            case 16:
              json = _context3.sent;
              json.url = url.toString();
              return _context3.abrupt("return", json);
            case 19:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
    }
  }, {
    key: "canRetrieve",
    value: function canRetrieve(suggestion) {
      var action = suggestion.action;
      return typeof (action == null ? void 0 : action.id) === "string";
    }
  }, {
    key: "responseHeaders",
    get: function get() {
      return __privateGet(this, _responseHeaders);
    }
  }]);
  return _AddressAutofillCore;
}();
var AddressAutofillCore = _AddressAutofillCore;
_responseHeaders = new WeakMap();
_getQueryParams = new WeakSet();
getQueryParams_fn = function getQueryParams_fn(options) {
  return queryParams({
    types: "address",
    access_token: this.accessToken,
    streets: options.streets,
    language: options.language,
    country: options.country,
    limit: options.limit
  }, options.sessionToken && {
    session_token: SessionToken.convert(options.sessionToken).id
  }, options.proximity && {
    proximity: typeof options.proximity === "string" ? options.proximity : LngLat.convert(options.proximity).toArray().join(",")
  }, options.bbox && {
    bbox: typeof options.bbox === "string" ? options.bbox : LngLatBounds.convert(options.bbox).toFlatArray().join(",")
  });
};
AddressAutofillCore.defaults = {
  language: "en",
  proximity: "ip",
  streets: true
};

// src/searchbox/constants.ts
var SEARCH_URL2 = "https://api.mapbox.com/search/searchbox/v1";
var ENDPOINT_SUGGEST2 = "suggest";
var ENDPOINT_RETRIEVE2 = "retrieve";
var ENDPOINT_CATEGORY = "category";
var ENDPOINT_REVERSE = "reverse";
var SUGGEST_URL2 = "".concat(SEARCH_URL2, "/").concat(ENDPOINT_SUGGEST2);
var RETRIEVE_URL2 = "".concat(SEARCH_URL2, "/").concat(ENDPOINT_RETRIEVE2);
var CATEGORY_URL = "".concat(SEARCH_URL2, "/").concat(ENDPOINT_CATEGORY);
var REVERSE_URL = "".concat(SEARCH_URL2, "/").concat(ENDPOINT_REVERSE);

// src/searchbox/SearchBoxCore.ts
var _getQueryParams2, getQueryParams_fn2;
var _SearchBoxCore = /*#__PURE__*/function () {
  function _SearchBoxCore() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    _classCallCheck(this, _SearchBoxCore);
    __privateAdd(this, _getQueryParams2);
    var _a = options,
      accessToken = _a.accessToken,
      defaults = __objRest(_a, ["accessToken"]);
    this.accessToken = accessToken;
    this.defaults = __spreadValues(__spreadValues({}, _SearchBoxCore.defaults), defaults);
  }
  _createClass(_SearchBoxCore, [{
    key: "suggest",
    value: function suggest(searchText, optionsArg) {
      return __async(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var sessionToken, signal, options, url, _getFetch3, fetch, res, json;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              if (searchText) {
                _context4.next = 2;
                break;
              }
              throw new Error("searchText is required");
            case 2:
              sessionToken = optionsArg.sessionToken, signal = optionsArg.signal;
              options = __spreadProps(__spreadValues(__spreadValues({}, this.defaults), optionsArg), {
                q: searchText,
                sessionToken: sessionToken
              });
              if (!(options.eta_type && (!options.origin || !options.navigation_profile))) {
                _context4.next = 6;
                break;
              }
              throw new Error("to provide eta estimate: eta, navigation_profile, and origin are required");
            case 6:
              if (!(options.origin && !options.navigation_profile)) {
                _context4.next = 8;
                break;
              }
              throw new Error("to provide distance estimate: both navigation_profile and origin are required");
            case 8:
              url = new URL(SUGGEST_URL2);
              url.search = __privateMethod(this, _getQueryParams2, getQueryParams_fn2).call(this, options);
              _getFetch3 = getFetch(), fetch = _getFetch3.fetch;
              _context4.next = 13;
              return fetch(url.toString(), {
                signal: signal
              });
            case 13:
              res = _context4.sent;
              _context4.next = 16;
              return handleNonOkRes(res);
            case 16:
              _context4.next = 18;
              return res.json();
            case 18:
              json = _context4.sent;
              json.url = url.toString();
              return _context4.abrupt("return", json);
            case 21:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
    }
  }, {
    key: "retrieve",
    value: function retrieve(suggestion, optionsArg) {
      return __async(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        var sessionTokenLike, signal, language, sessionToken, options, url, _getFetch4, fetch, res, json;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              if (suggestion) {
                _context5.next = 2;
                break;
              }
              throw new Error("suggestion is required");
            case 2:
              sessionTokenLike = optionsArg.sessionToken, signal = optionsArg.signal, language = optionsArg.language;
              sessionToken = SessionToken.convert(sessionTokenLike);
              options = __spreadValues(__spreadValues({}, this.defaults), language && {
                language: language
              });
              url = new URL("".concat(RETRIEVE_URL2, "/").concat(encodeURIComponent(suggestion.mapbox_id)));
              url.search = queryParams({
                access_token: this.accessToken,
                session_token: sessionToken.id
              }, {
                language: options.language
              });
              _getFetch4 = getFetch(), fetch = _getFetch4.fetch;
              _context5.next = 10;
              return fetch(url.toString(), {
                signal: signal
              });
            case 10:
              res = _context5.sent;
              _context5.next = 13;
              return handleNonOkRes(res);
            case 13:
              _context5.next = 15;
              return res.json();
            case 15:
              json = _context5.sent;
              json.url = url.toString();
              return _context5.abrupt("return", json);
            case 18:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
    }
  }, {
    key: "category",
    value: function category(_0) {
      return __async(this, arguments, function (category) {
        var _this2 = this;
        var optionsArg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        return /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
          var options, url, _getFetch5, fetch, res, json;
          return _regeneratorRuntime().wrap(function _callee6$(_context6) {
            while (1) switch (_context6.prev = _context6.next) {
              case 0:
                if (category) {
                  _context6.next = 2;
                  break;
                }
                throw new Error("category is required");
              case 2:
                options = __spreadValues(__spreadValues({}, _this2.defaults), optionsArg);
                url = new URL("".concat(CATEGORY_URL, "/").concat(encodeURIComponent(category)));
                url.search = __privateMethod(_this2, _getQueryParams2, getQueryParams_fn2).call(_this2, options);
                _getFetch5 = getFetch(), fetch = _getFetch5.fetch;
                _context6.next = 8;
                return fetch(url.toString(), {
                  signal: options.signal
                });
              case 8:
                res = _context6.sent;
                _context6.next = 11;
                return handleNonOkRes(res);
              case 11:
                _context6.next = 13;
                return res.json();
              case 13:
                json = _context6.sent;
                json.url = url.toString();
                return _context6.abrupt("return", json);
              case 16:
              case "end":
                return _context6.stop();
            }
          }, _callee6);
        })();
      });
    }
  }, {
    key: "reverse",
    value: function reverse(_0) {
      return __async(this, arguments, function (lngLat) {
        var _this3 = this;
        var optionsArg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        return /*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
          var _ref2, _ref3, lng, lat, options, url, _getFetch6, fetch, res, json;
          return _regeneratorRuntime().wrap(function _callee7$(_context7) {
            while (1) switch (_context7.prev = _context7.next) {
              case 0:
                if (lngLat) {
                  _context7.next = 2;
                  break;
                }
                throw new Error("lngLat is required");
              case 2:
                _ref2 = typeof lngLat === "string" ? lngLat.split(",").map(function (x) {
                  return parseFloat(x);
                }) : LngLat.convert(lngLat).toArray(), _ref3 = _slicedToArray(_ref2, 2), lng = _ref3[0], lat = _ref3[1];
                if (!(isNaN(lng) || isNaN(lat))) {
                  _context7.next = 5;
                  break;
                }
                throw new Error("lngLat is required");
              case 5:
                options = __spreadValues(__spreadValues({}, _this3.defaults), optionsArg);
                url = new URL(REVERSE_URL);
                url.search = queryParams({
                  access_token: _this3.accessToken,
                  language: options.language,
                  limit: options.limit,
                  longitude: lng,
                  latitude: lat
                }, options.types && {
                  types: typeof options.types === "string" ? options.types : _toConsumableArray(options.types).join(",")
                });
                _getFetch6 = getFetch(), fetch = _getFetch6.fetch;
                _context7.next = 11;
                return fetch(url.toString(), {
                  signal: options.signal
                });
              case 11:
                res = _context7.sent;
                _context7.next = 14;
                return handleNonOkRes(res);
              case 14:
                _context7.next = 16;
                return res.json();
              case 16:
                json = _context7.sent;
                json.url = url.toString();
                return _context7.abrupt("return", json);
              case 19:
              case "end":
                return _context7.stop();
            }
          }, _callee7);
        })();
      });
    }
  }]);
  return _SearchBoxCore;
}();
var SearchBoxCore = _SearchBoxCore;
_getQueryParams2 = new WeakSet();
getQueryParams_fn2 = function getQueryParams_fn2(options) {
  return queryParams({
    q: options.q,
    access_token: this.accessToken,
    language: options.language,
    limit: options.limit,
    navigation_profile: options.navigation_profile,
    route: options.route,
    route_geometry: options.route_geometry,
    sar_type: options.sar_type,
    time_deviation: options.time_deviation,
    eta_type: options.eta_type,
    country: options.country,
    poi_category: options.poi_category,
    rich_metadata_provider: options.rich_metadata_provider,
    poi_category_exclusions: options.poi_category_exclusions
  }, options.sessionToken && {
    session_token: SessionToken.convert(options.sessionToken).id
  }, options.proximity && {
    proximity: typeof options.proximity === "string" ? options.proximity : LngLat.convert(options.proximity).toArray().join(",")
  }, options.origin && {
    origin: typeof options.origin === "string" ? options.origin : LngLat.convert(options.origin).toArray().join(",")
  }, options.bbox && {
    bbox: typeof options.bbox === "string" ? options.bbox : LngLatBounds.convert(options.bbox).toFlatArray().join(",")
  }, options.types && {
    types: typeof options.types === "string" ? options.types : _toConsumableArray(options.types).join(",")
  });
};
SearchBoxCore.defaults = {
  language: "en"
};

// src/validate/constants.ts
var SEARCH_URL3 = "https://api.mapbox.com/autofill/v1";
var ENDPOINT_VALIDATE = "retrieve";
var VALIDATE_URL = "".concat(SEARCH_URL3, "/").concat(ENDPOINT_VALIDATE);

// src/validate/ValidationCore.ts
var _getQueryParams3, getQueryParams_fn3;
var _ValidationCore = /*#__PURE__*/function () {
  function _ValidationCore() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    _classCallCheck(this, _ValidationCore);
    __privateAdd(this, _getQueryParams3);
    var _a = options,
      accessToken = _a.accessToken,
      defaults = __objRest(_a, ["accessToken"]);
    this.accessToken = accessToken;
    this.defaults = __spreadValues(__spreadValues({}, _ValidationCore.defaults), defaults);
  }
  _createClass(_ValidationCore, [{
    key: "validate",
    value: function validate(searchText, optionsArg) {
      return __async(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
        var sessionToken, signal, options, url, _getFetch7, fetch, res, json;
        return _regeneratorRuntime().wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              if (searchText) {
                _context8.next = 2;
                break;
              }
              throw new Error("searchText is required");
            case 2:
              sessionToken = optionsArg.sessionToken, signal = optionsArg.signal;
              options = __spreadProps(__spreadValues(__spreadValues({}, this.defaults), optionsArg), {
                sessionToken: sessionToken
              });
              url = new URL("".concat(VALIDATE_URL, "/").concat(encodeURIComponent(searchText)));
              url.search = __privateMethod(this, _getQueryParams3, getQueryParams_fn3).call(this, options);
              _getFetch7 = getFetch(), fetch = _getFetch7.fetch;
              _context8.next = 9;
              return fetch(url.toString(), {
                signal: signal
              });
            case 9:
              res = _context8.sent;
              _context8.next = 12;
              return handleNonOkRes(res);
            case 12:
              _context8.next = 14;
              return res.json();
            case 14:
              json = _context8.sent;
              json.url = url.toString();
              if (json.features.length > 0) {
                json.features = [json.features[0]];
              }
              return _context8.abrupt("return", json);
            case 18:
            case "end":
              return _context8.stop();
          }
        }, _callee8, this);
      }));
    }
  }]);
  return _ValidationCore;
}();
var ValidationCore = _ValidationCore;
_getQueryParams3 = new WeakSet();
getQueryParams_fn3 = function getQueryParams_fn3(options) {
  return queryParams({
    access_token: this.accessToken,
    language: options.language,
    country: options.country
  }, options.sessionToken && {
    session_token: SessionToken.convert(options.sessionToken).id
  }, options.proximity && {
    proximity: typeof options.proximity === "string" ? options.proximity : LngLat.convert(options.proximity).toArray().join(",")
  }, options.bbox && {
    bbox: typeof options.bbox === "string" ? options.bbox : LngLatBounds.convert(options.bbox).toFlatArray().join(",")
  });
};
ValidationCore.defaults = {
  language: "en",
  proximity: "ip"
};

// src/geocode/constants.ts
var BASE_URL = "https://api.mapbox.com/search/geocode/v6";
var FORWARD_URL = "".concat(BASE_URL, "/forward");
var REVERSE_URL2 = "".concat(BASE_URL, "/reverse");
var BATCH_URL = "".concat(BASE_URL, "/batch");

// src/geocode/GeocodingCore.ts
var REVERSE_GEOCODE_COORD_REGEX = /^[ ]*(-?\d{1,3}(\.\d{0,256})?)[, ]+(-?\d{1,3}(\.\d{0,256})?)[ ]*$/;
var SPACES_OR_COMMA_REGEX = /[\s,]+/;
var _responseHeaders2, _getQueryParams4, getQueryParams_fn4;
var GeocodingCore = /*#__PURE__*/function () {
  function GeocodingCore() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    _classCallCheck(this, GeocodingCore);
    __privateAdd(this, _getQueryParams4);
    __privateAdd(this, _responseHeaders2, void 0);
    var _a = options,
      accessToken = _a.accessToken,
      defaults = __objRest(_a, ["accessToken"]);
    this.accessToken = accessToken;
    this.defaults = __spreadValues({}, defaults);
  }
  _createClass(GeocodingCore, [{
    key: "forward",
    value: function forward(searchText, optionsArg) {
      return __async(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee9() {
        var signal, options, url, _getFetch8, fetch, fetchInit, res, json;
        return _regeneratorRuntime().wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              if (searchText) {
                _context9.next = 2;
                break;
              }
              throw new Error("searchText is required");
            case 2:
              if (optionsArg) {
                signal = optionsArg.signal;
              }
              options = __spreadProps(__spreadValues(__spreadValues({}, this.defaults), optionsArg), {
                q: searchText
              });
              url = new URL("".concat(FORWARD_URL));
              url.search = __privateMethod(this, _getQueryParams4, getQueryParams_fn4).call(this, options);
              _getFetch8 = getFetch(), fetch = _getFetch8.fetch;
              fetchInit = signal ? {
                signal: signal
              } : {};
              _context9.next = 10;
              return fetch(url.toString(), fetchInit);
            case 10:
              res = _context9.sent;
              __privateSet(this, _responseHeaders2, res.headers);
              _context9.next = 14;
              return handleNonOkRes(res);
            case 14:
              _context9.next = 16;
              return res.json();
            case 16:
              json = _context9.sent;
              json.url = url.toString();
              return _context9.abrupt("return", json);
            case 19:
            case "end":
              return _context9.stop();
          }
        }, _callee9, this);
      }));
    }
  }, {
    key: "reverse",
    value: function reverse(lngLat, optionsArg) {
      return __async(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee10() {
        var signal, lngLatObj, _lngLat$split, _lngLat$split2, lng, lat, options, url, _getFetch9, fetch, fetchInit, res, json;
        return _regeneratorRuntime().wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              if (lngLat) {
                _context10.next = 2;
                break;
              }
              throw new Error("lngLat is required");
            case 2:
              if (optionsArg) {
                signal = optionsArg.signal;
              }
              if (typeof lngLat === "string") {
                _lngLat$split = lngLat.split(","), _lngLat$split2 = _slicedToArray(_lngLat$split, 2), lng = _lngLat$split2[0], lat = _lngLat$split2[1];
                lngLatObj = new LngLat(Number(lng), Number(lat));
              } else {
                lngLatObj = LngLat.convert(lngLat);
              }
              options = __spreadProps(__spreadValues(__spreadValues({}, this.defaults), optionsArg), {
                longitude: lngLatObj.lng,
                latitude: lngLatObj.lat
              });
              url = new URL("".concat(REVERSE_URL2));
              url.search = __privateMethod(this, _getQueryParams4, getQueryParams_fn4).call(this, options, true);
              _getFetch9 = getFetch(), fetch = _getFetch9.fetch;
              fetchInit = signal ? {
                signal: signal
              } : {};
              _context10.next = 11;
              return fetch(url.toString(), fetchInit);
            case 11:
              res = _context10.sent;
              __privateSet(this, _responseHeaders2, res.headers);
              _context10.next = 15;
              return handleNonOkRes(res);
            case 15:
              _context10.next = 17;
              return res.json();
            case 17:
              json = _context10.sent;
              json.url = url.toString();
              return _context10.abrupt("return", json);
            case 20:
            case "end":
              return _context10.stop();
          }
        }, _callee10, this);
      }));
    }
  }, {
    key: "suggest",
    value: function suggest(searchText, optionsArg) {
      return __async(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee11() {
        var isReverseQuery, coordinates;
        return _regeneratorRuntime().wrap(function _callee11$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              isReverseQuery = REVERSE_GEOCODE_COORD_REGEX.test(searchText);
              if (!isReverseQuery) {
                _context11.next = 6;
                break;
              }
              coordinates = searchText.trim().split(SPACES_OR_COMMA_REGEX).map(function (part) {
                return part.trim();
              }).join(",");
              return _context11.abrupt("return", this.reverse(coordinates, optionsArg));
            case 6:
              return _context11.abrupt("return", this.forward(searchText, optionsArg));
            case 7:
            case "end":
              return _context11.stop();
          }
        }, _callee11, this);
      }));
    }
  }, {
    key: "retrieve",
    value: function retrieve(suggestion) {
      return __async(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee12() {
        return _regeneratorRuntime().wrap(function _callee12$(_context12) {
          while (1) switch (_context12.prev = _context12.next) {
            case 0:
              return _context12.abrupt("return", suggestion);
            case 1:
            case "end":
              return _context12.stop();
          }
        }, _callee12);
      }));
    }
  }, {
    key: "responseHeaders",
    get: function get() {
      return __privateGet(this, _responseHeaders2);
    }
  }]);
  return GeocodingCore;
}();
_responseHeaders2 = new WeakMap();
_getQueryParams4 = new WeakSet();
getQueryParams_fn4 = function getQueryParams_fn4(options) {
  var isReverse = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  if (isReverse) {
    ["proximity", "autocomplete", "bbox"].forEach(function (key) {
      if (key in options) {
        delete options[key];
      }
    });
  }
  return queryParams({
    q: options.q,
    longitude: options.longitude,
    latitude: options.latitude,
    access_token: this.accessToken,
    permanent: options.permanent,
    language: options.language,
    country: options.country,
    limit: options.limit,
    autocomplete: options.autocomplete,
    worldview: options.worldview
  }, options.sessionToken && {
    session_token: SessionToken.convert(options.sessionToken).id
  }, options.proximity && {
    proximity: typeof options.proximity === "string" ? options.proximity : LngLat.convert(options.proximity).toArray().join(",")
  }, options.bbox && {
    bbox: typeof options.bbox === "string" ? options.bbox : LngLatBounds.convert(options.bbox).toFlatArray().join(",")
  }, options.types && {
    types: typeof options.types === "string" ? options.types : _toConsumableArray(options.types).join(",")
  });
};

// src/types.ts
var MatchCodeType = /* @__PURE__ */function (MatchCodeType2) {
  MatchCodeType2["matched"] = "matched";
  MatchCodeType2["unmatched"] = "unmatched";
  MatchCodeType2["plausible"] = "plausible";
  MatchCodeType2["not_applicable"] = "not_applicable";
  MatchCodeType2["inferred"] = "inferred";
  return MatchCodeType2;
}(MatchCodeType || {});
var MatchCodeConfidence = /* @__PURE__ */function (MatchCodeConfidence2) {
  MatchCodeConfidence2["exact"] = "exact";
  MatchCodeConfidence2["high"] = "high";
  MatchCodeConfidence2["medium"] = "medium";
  MatchCodeConfidence2["low"] = "low";
  return MatchCodeConfidence2;
}(MatchCodeConfidence || {});

// src/utils/Evented.ts
var _listeners;
var Evented = /*#__PURE__*/function () {
  function Evented() {
    _classCallCheck(this, Evented);
    __privateAdd(this, _listeners, {});
  }
  _createClass(Evented, [{
    key: "addEventListener",
    value: function addEventListener(type, listener) {
      var listenersArr = __privateGet(this, _listeners);
      if (!listenersArr[type]) {
        listenersArr[type] = [];
      }
      listenersArr[type].push(listener);
    }
  }, {
    key: "removeEventListener",
    value: function removeEventListener(type, listener) {
      var listenersArr = __privateGet(this, _listeners);
      if (!listenersArr[type]) {
        return;
      }
      var listeners = listenersArr[type];
      var index = listeners.indexOf(listener);
      if (index !== -1) {
        listeners.splice(index, 1);
      }
    }
  }, {
    key: "fire",
    value: function fire(type, arg0) {
      var listenersArr = __privateGet(this, _listeners);
      if (!listenersArr[type]) {
        return;
      }
      var listeners = listenersArr[type];
      var _iterator3 = _createForOfIteratorHelper(listeners),
        _step3;
      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var listener = _step3.value;
          listener(arg0);
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
    }
  }]);
  return Evented;
}();
_listeners = new WeakMap();

// src/utils/debounce.ts
function debounce(func, wait, signalFn) {
  var timeout = null;
  return function () {
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }
    if (timeout !== null) {
      clearTimeout(timeout);
    }
    var signal = signalFn && signalFn();
    timeout = setTimeout(function () {
      timeout = null;
      if (signal == null ? void 0 : signal.aborted) {
        return;
      }
      func.apply(void 0, args);
    }, wait);
  };
}

// src/SearchSession.ts
function createAbortController() {
  var _getFetch10 = getFetch(),
    AbortController = _getFetch10.AbortController;
  return new AbortController();
}
var _sessionTokenBase, _sessionIncrementer, _sessionTokenCustom, _suggestions, _abort, _suggestDebounce;
var SearchSession = /*#__PURE__*/function (_Evented) {
  _inherits(SearchSession, _Evented);
  function SearchSession(search) {
    var _this4;
    var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    _classCallCheck(this, SearchSession);
    _this4 = _possibleConstructorReturn(this, _getPrototypeOf(SearchSession).call(this));
    __privateAdd(_assertThisInitialized(_assertThisInitialized(_this4)), _sessionTokenBase, new SessionToken());
    __privateAdd(_assertThisInitialized(_assertThisInitialized(_this4)), _sessionIncrementer, 0);
    __privateAdd(_assertThisInitialized(_assertThisInitialized(_this4)), _sessionTokenCustom, false);
    __privateAdd(_assertThisInitialized(_assertThisInitialized(_this4)), _suggestions, void 0);
    __privateAdd(_assertThisInitialized(_assertThisInitialized(_this4)), _abort, createAbortController());
    __privateAdd(_assertThisInitialized(_assertThisInitialized(_this4)), _suggestDebounce, void 0);
    __privateSet(_assertThisInitialized(_assertThisInitialized(_this4)), _suggestDebounce, debounce(function (_0) {
      for (var _len3 = arguments.length, _1 = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
        _1[_key3 - 1] = arguments[_key3];
      }
      return __async(_assertThisInitialized(_assertThisInitialized(_this4)), [_0].concat(_1), function (searchText) {
        var _this5 = this;
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        return /*#__PURE__*/_regeneratorRuntime().mark(function _callee13() {
          var res;
          return _regeneratorRuntime().wrap(function _callee13$(_context13) {
            while (1) switch (_context13.prev = _context13.next) {
              case 0:
                __privateGet(_this5, _abort).abort();
                __privateSet(_this5, _abort, createAbortController());
                if (searchText) {
                  _context13.next = 6;
                  break;
                }
                __privateSet(_this5, _suggestions, null);
                _this5.fire("suggest", __privateGet(_this5, _suggestions));
                return _context13.abrupt("return");
              case 6:
                _context13.prev = 6;
                _context13.next = 9;
                return _this5.search.suggest(searchText, __spreadProps(__spreadValues({
                  sessionToken: _this5.sessionToken
                }, options), {
                  signal: __privateGet(_this5, _abort).signal
                }));
              case 9:
                res = _context13.sent;
                __privateSet(_this5, _suggestions, res);
                _this5.fire("suggest", res);
                _context13.next = 19;
                break;
              case 14:
                _context13.prev = 14;
                _context13.t0 = _context13["catch"](6);
                if (!(_context13.t0.name === "AbortError")) {
                  _context13.next = 18;
                  break;
                }
                return _context13.abrupt("return");
              case 18:
                _this5.fire("suggesterror", _context13.t0);
              case 19:
              case "end":
                return _context13.stop();
            }
          }, _callee13, null, [[6, 14]]);
        })();
      });
    }, wait, function () {
      return __privateGet(_assertThisInitialized(_assertThisInitialized(_this4)), _abort).signal;
    }));
    Object.defineProperties(_assertThisInitialized(_assertThisInitialized(_this4)), {
      search: {
        value: search,
        writable: false
      },
      debounce: {
        value: wait,
        writable: false
      }
    });
    return _this4;
  }
  _createClass(SearchSession, [{
    key: "suggest",
    value: function suggest(searchText, options) {
      var _this6 = this;
      __privateGet(this, _suggestDebounce).call(this, searchText, options);
      return new Promise(function (resolve, reject) {
        var _suggestFn;
        var _suggestErrorFn;
        _suggestFn = function suggestFn(res) {
          _this6.removeEventListener("suggest", _suggestFn);
          _this6.removeEventListener("suggesterror", _suggestErrorFn);
          resolve(res);
        };
        _suggestErrorFn = function suggestErrorFn(err) {
          _this6.removeEventListener("suggest", _suggestFn);
          _this6.removeEventListener("suggesterror", _suggestErrorFn);
          reject(err);
        };
        _this6.addEventListener("suggest", _suggestFn);
        _this6.addEventListener("suggesterror", _suggestErrorFn);
      });
    }
  }, {
    key: "clear",
    value: function clear() {
      this.suggest("");
    }
  }, {
    key: "retrieve",
    value: function retrieve(suggestion, options) {
      return __async(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee14() {
        var res;
        return _regeneratorRuntime().wrap(function _callee14$(_context14) {
          while (1) switch (_context14.prev = _context14.next) {
            case 0:
              _context14.next = 2;
              return this.search.retrieve(suggestion, __spreadValues({
                sessionToken: this.sessionToken
              }, options));
            case 2:
              res = _context14.sent;
              this.fire("retrieve", res);
              return _context14.abrupt("return", res);
            case 5:
            case "end":
              return _context14.stop();
          }
        }, _callee14, this);
      }));
    }
  }, {
    key: "canRetrieve",
    value: function canRetrieve(suggestion) {
      if (!this.search.canRetrieve) {
        return true;
      }
      return this.search.canRetrieve(suggestion);
    }
  }, {
    key: "canSuggest",
    value: function canSuggest(suggestion) {
      if (!this.search.canSuggest) {
        return true;
      }
      return this.search.canSuggest(suggestion);
    }
  }, {
    key: "abort",
    value: function abort() {
      __privateGet(this, _abort).abort();
      __privateSet(this, _abort, createAbortController());
    }
  }, {
    key: "incrementSession",
    value: function incrementSession() {
      __privateWrapper(this, _sessionIncrementer)._++;
    }
  }, {
    key: "sessionToken",
    get: function get() {
      if (__privateGet(this, _sessionTokenCustom)) {
        return __privateGet(this, _sessionTokenBase).id;
      }
      return "".concat(__privateGet(this, _sessionTokenBase).id, ".").concat(__privateGet(this, _sessionIncrementer));
    },
    set: function set(token) {
      __privateSet(this, _sessionTokenCustom, true);
      __privateSet(this, _sessionTokenBase, new SessionToken(token));
    }
  }, {
    key: "suggestions",
    get: function get() {
      return __privateGet(this, _suggestions);
    }
  }]);
  return SearchSession;
}(Evented);
_sessionTokenBase = new WeakMap();
_sessionIncrementer = new WeakMap();
_sessionTokenCustom = new WeakMap();
_suggestions = new WeakMap();
_abort = new WeakMap();
_suggestDebounce = new WeakMap();

// src/featureToSuggestion.ts
function featureToSuggestion(feature) {
  var properties = feature.properties;
  return __spreadValues({}, properties);
}
export { AddressAutofillCore, Evented, GeocodingCore, LngLat, LngLatBounds, AddressAutofillCore as MapboxAutofill, MapboxError, GeocodingCore as MapboxGeocode, ValidationCore as MapboxValidate, MatchCodeConfidence, MatchCodeType, SearchBoxCore, SearchSession, SessionToken, ValidationCore, debounce, featureToSuggestion, polyfillFetch };